import { StyleSheet } from 'aphrodite/no-important';
import constants from '../../constants/styles';
const { LOGIN_BG_COLOR, NO_SITES_FOUND_LINK } = constants;

let styles = {
  base: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    backgroundColor: LOGIN_BG_COLOR,
    color: 'white'
  },
  item: {
    margin: '20px 0px'
  },
  link: {
    color: NO_SITES_FOUND_LINK
  }
};

export default StyleSheet.create(styles);



// WEBPACK FOOTER //
// ./src/containers/nositesfound/NoSitesFound.styles.js